
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 246","d":"M6.4 32a25.47 25.47 0 018.38-18.82l4.9 4.9a1.6 1.6 0 002.72-1.15V3.2a1.6 1.6 0 00-1.6-1.6H7.07A1.61 1.61 0 006 4.32l4.29 4.32A31.92 31.92 0 0024.83 63.2a3.24 3.24 0 004-3.14 3.24 3.24 0 00-2.53-3.13A25.61 25.61 0 016.4 32zM64 32A32 32 0 0039.17.8a3.24 3.24 0 00-4 3.14 3.24 3.24 0 002.53 3.13 25.48 25.48 0 0111.52 43.75l-4.9-4.9a1.6 1.6 0 00-2.72 1.15V60.8a1.6 1.6 0 001.6 1.6h13.73a1.6 1.6 0 001.12-2.72l-4.29-4.32A31.81 31.81 0 0064 32z"}})])
          )
        }
      }
    